import axios from 'axios'

const state = () => ({
  ourService: []
})

const getters = {
  ourService(state) {
    return state.ourService
  }
}

const mutations = {
  SET_OURSERVICE(state, payload){
    state.ourService = payload
  },
  DELETE_OURSERVICE(state, id){
    state.ourService.results = state.ourService.results.filter((x) => x.id != id);
  },
  ADD_OURSERVICE(state, data){
    state.ourService.results.push(data);
  },
  EDIT_OURSERVICE(state, payload){
    state.ourService.results = state.ourService.results.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getOurService({commit}){
    axios.get('https://api.geomalaka.uz/api/about/bizning-xizmatlar/')
    .then((res)=>{
      commit("SET_OURSERVICE", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteOurService({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/about/bizning-xizmatlar/${id}/`)
    .then((res)=>{
      commit("DELETE_OURSERVICE", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addOurService({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/about/bizning-xizmatlar/', payload)
    .then((res)=>{
      commit("ADD_OURSERVICE", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editOurService({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/about/bizning-xizmatlar/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_OURSERVICE", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

